import React from 'react';

import { storyContent } from '../../constants';

import * as S from './styles';

function StorySection() {
  return (
    <S.Container>
      {storyContent.map((story, index) => {
        const isDarkBackground = index !== 1;

        return (
          <S.StoryRow key={story.id} reverse={index === 1}>
            <S.ImageWrapper>
              {story.imageUrl && (
                <S.Image alt={story.subtitle} src={story.imageUrl} />
              )}
            </S.ImageWrapper>
            <S.Content darkBackground={isDarkBackground}>
              <S.NumberText darkBackground={isDarkBackground}>
                {index + 1}.
              </S.NumberText>
              <S.BodyText darkBackground={isDarkBackground}>
                {story.bodyText}
              </S.BodyText>
              <S.Subtitle darkBackground={isDarkBackground}>
                {story.subtitle}
              </S.Subtitle>
            </S.Content>
          </S.StoryRow>
        );
      })}
    </S.Container>
  );
}

export default StorySection;
